import { render, staticRenderFns } from "./RoutingDetails.vue?vue&type=template&id=05c5e0cb"
import script from "./RoutingDetails.vue?vue&type=script&lang=js"
export * from "./RoutingDetails.vue?vue&type=script&lang=js"
import style0 from "./RoutingDetails.vue?vue&type=style&index=0&id=05c5e0cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports